import { ArrowRightIcon } from '@persona-id/design-tokens/icons/24px';

import { ModalBody, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { OrganizationPlan, OrganizationPlanKey } from 'dashboard/models/organization-plan';
import { OrganizationPlanMigration } from 'dashboard/models/organization-plan-migration';
import { ModalV2Header } from 'dashboard/views/DashboardSandboxHomeView/BlueprintsQuizV2Modal/BlueprintsQuizV2ModalLayout';
import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';

interface BlueprintsQuizV2StartProps {
  currentOrganizationPlan: OrganizationPlan | null;
  pendingOrganizationPlanMigration: OrganizationPlanMigration;
  toNextScreen: () => void;
  closeModal: () => void;
}

export const BlueprintsQuizV2Start = ({
  currentOrganizationPlan,
  pendingOrganizationPlanMigration,
  toNextScreen,
  closeModal,
}: BlueprintsQuizV2StartProps) => {
  const modalBodyText = () => {
    const requestedPlanName =
      pendingOrganizationPlanMigration?.attributes?.['requested-plan-display-name'];

    if (requestedPlanName) {
      return (
        <>
          <Paragraph size='md' color='primary'>
            Persona helps you collect, verify, understand, and orchestrate your customer’s data.
            While we work on getting your environment set up, let’s find the right solution for your
            needs and help you explore our Sandbox environment.
          </Paragraph>
          <Spacer height={1}></Spacer>
          <Paragraph size='md' color='primary'>
            If you requested a trial of one of our paid plans, we’re reviewing your request and you
            can expect an email update within 5 business days.
          </Paragraph>
        </>
      );
    } else if (
      currentOrganizationPlan?.attributes?.['key'] === OrganizationPlanKey.TrialEssential
    ) {
      return (
        <>
          <Paragraph size='lg' color='primary' weight='bold'>
            Congrats! We’ve started your trial.
          </Paragraph>
          <Spacer height={1}></Spacer>
          <Paragraph size='md' color='primary'>
            Persona helps you collect, verify, understand, and orchestrate your customer’s data. We
            have a few questions to ask you that’ll help us find the right starting solution for
            your needs.
          </Paragraph>
        </>
      );
    } else {
      return (
        <>
          <Paragraph size='lg' color='primary' weight='bold'>
            Let’s get started.
          </Paragraph>
          <Spacer height={1}></Spacer>
          <Paragraph size='md' color='primary'>
            Persona helps you collect, verify, understand, and orchestrate your your customer’s
            data. We have a few questions to ask you that’ll help us find the right starting
            solution for your needs.
          </Paragraph>
        </>
      );
    }
  };

  return (
    <>
      <ModalHeader onClose={closeModal}>
        <ModalV2Header>Welcome to Persona!</ModalV2Header>
      </ModalHeader>
      <ModalBody>
        {modalBodyText()}
        <Spacer height={2}></Spacer>
        <Button
          aria-label='blueprints-quiz-v2-start__button-next'
          width='auto'
          type='button'
          onClick={() => toNextScreen()}
          suffixIcon={<ArrowRightIcon />}
        >
          Next
        </Button>
      </ModalBody>
    </>
  );
};
